import React, { useEffect, useState, useRef } from 'react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import styled from 'styled-components'
import { colors } from '../../styles/colors'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useStores from '../../stores/useStore'

const StyledContainer = styled.div`
  margin-top: 32px;
`

const StyledTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 12px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
  color: ${colors.secondary};
`

const StyledList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px;
`

const StyledItem = styled.li`
  display: flex;
`

const CardLink = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-decoration: none;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
`

const StyledImageWrapper = styled.div`
  width: 100%;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 12px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

const StyledItemTitle = styled.div`
  color: ${colors.secondary};
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
`

const OrderableAccessories = ({ basketId, articleId }) => {
  const [accessoires, setAccessoires] = useState([])
  const { t } = useTranslation()
  const mountedRef = useRef(true)
  const { productDetailsStore } = useStores()
  let currentLocation = useLocation()

  //Cleanup Function
  useEffect(() => {
    return () => {
      mountedRef.current = false
    }
  }, [])

  useEffect(() => {
    apiClient
      .getJson(APIEndpoints.orderableAccessories(basketId, articleId))
      .then((response) => {
        if (!mountedRef.current) {
          return null
        }
        setAccessoires(response)
      })
  }, [articleId, basketId])

  if (accessoires.length === 0) {
    return null
  }

  return (
    <StyledContainer>
      <StyledTitle className='h1'>
        {t('OrderableAccessories:matchingProducts')}
      </StyledTitle>
      <StyledList>
        {accessoires.map((article) => (
          <StyledItem key={article.id}>
            <CardLink
              to={productDetailsStore.getProductToUrl(article)}
              state={{
                from: currentLocation.pathname,
                backLabel: t('backButton'),
              }}
            >
              <StyledImageWrapper>
                <img
                  src={article.article.image && article.article.image.url}
                  alt=''
                />
              </StyledImageWrapper>
              <StyledItemTitle>{article.article.displayName}</StyledItemTitle>
            </CardLink>
          </StyledItem>
        ))}
      </StyledList>
    </StyledContainer>
  )
}

export default OrderableAccessories
